import { sendException } from '../lib/google-analytics';

export const FruitType = {
  Apple: 2213 as const,
  Orange: 2214 as const,
  Pear: 2285 as const,
  Peach: 2286 as const,
  Cherry: 2287 as const
};

export type Fruit = typeof FruitType[keyof typeof FruitType];

export function getFruitById(id: number): Fruit | undefined {
  switch (id) {
    case 2213:
      return FruitType.Apple;
    case 2214:
      return FruitType.Orange;
    case 2285:
      return FruitType.Pear;
    case 2286:
      return FruitType.Peach;
    case 2287:
      return FruitType.Cherry;
    default:
      sendException(`Unknown fruit id ${id} was detected`);
      return undefined;
  }
}
